import { css } from 'styled-components';

const Register = css`
  @media (max-width: 1024px) {
    display: none;
  }
`;

export default Register;
